import { render, staticRenderFns } from "./ForceRestore.vue?vue&type=template&id=23f9346c&scoped=true"
import script from "./ForceRestore.vue?vue&type=script&lang=ts"
export * from "./ForceRestore.vue?vue&type=script&lang=ts"
import style0 from "./ForceRestore.vue?vue&type=style&index=0&id=23f9346c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f9346c",
  null
  
)

export default component.exports